"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCustoClass = void 0;

var __1 = require("..");

var texts_1 = require("../classes/texts");

var hook_1 = require("../classes/hook");

var data_1 = require("../classes/data");

exports.isCustoClass = function (el) {
  return el instanceof __1.CustoComponent || el instanceof texts_1.CustoText || el instanceof data_1.CustoData || el instanceof hook_1.CustoHook;
};